<template>
    <AppModal :name="name"
              :beforeClose="beforeClose"
              :beforeOpen="beforeOpen"
              :onEnterKeyPress="copyToTeam"
              width="500">

        <template v-slot:header>
            Copy to team
        </template>

        <template v-slot:content>
            <div v-if="!subtypes || subtypes.length === 0" class="text-muted">
                No data
            </div>
            <template v-else>
                <div class="text-left">
                    <label>Team</label>
                    <multiselect
                        v-model="team"
                        @change="vuelidateDelayTouch($v.team, touchMap)"
                        :options="filteredTeams"
                        trackBy="uuid"
                        label="name"
                        class="multiselect-md"
                        placeholder="Select a team"/>
                    <small v-if="$v.team.$error" class="form-text text-danger">
                        <span v-if="!$v.team.required">This field is required</span>
                    </small>
                </div>

                <div class="text-left mt-3">
                    <label>Document types</label>
                    <multiselect
                        v-model="selectedSubtypes"
                        @change="vuelidateDelayTouch($v.team, touchMap)"
                        :options="subtypes"
                        multiple
                        trackBy="uuid"
                        label="display"
                        class="multiselect-md"
                        placeholder="Select document types"/>
                    <small v-if="$v.selectedSubtypes.$error" class="form-text text-danger">
                        <span v-if="!$v.selectedSubtypes.required">This field is required</span>
                    </small>
                </div>
            </template>
        </template>

        <template v-slot:actions>
            <div class="text-right">
                <button @click="$modal.hide(name)" class="btn btn-link d-inline-block">
                    Close
                </button>
                <button v-loading.btn="isLoading" @click="copyToTeam" class="btn btn-primary d-inline-block">
                    Copy
                </button>
            </div>
        </template>

    </AppModal>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import {mapGetters} from 'vuex'
import {documentTypesApiService} from '@/api/document/types'
import {showErrorMessage, showSuccessMessage} from '@/services/snackbar'
import {AppDocSystemTypes} from '@/types/document/types'

export default {
    name: 'DocSubtypeCopyToTeam',
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            team: null,
            subtypes: [],
            selectedSubtypes: [],
            isLoading: false,
            touchMap: new WeakMap()
        }
    },
    validations: {
        team: {required},
        selectedSubtypes: {required}
    },
    computed: {
        ...mapGetters([
            'activeTeamId',
            'getTeams'
        ]),

        filteredTeams() {
            return this.getTeams.filter(team => team.uuid !== this.activeTeamId)
        }
    },
    methods: {
        beforeClose() {
            this.subtypes = []
            Object.assign(this.$data, this.$options.data.apply(this))
            this.$v.$reset()
        },

        beforeOpen({params}) {
            this.subtypes = params.subtypes || []
        },

        async copyToTeam() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }
            this.isLoading = true
            const section = _.get(_.first(this.selectedSubtypes), 'section', AppDocSystemTypes.PURCHASING)
            const subtypeCodes = this.selectedSubtypes.map(subtype => subtype.property)
            const {error} = await documentTypesApiService.copySubtypesToTeam({
                type: section,
                teamId: this.team.uuid,
                data: subtypeCodes
            })
            if (error) {
                showErrorMessage('Something went wrong')
            } else {
                showSuccessMessage('Copied successfully')
                this.$modal.hide(this.name)
            }
            this.isLoading = false
        }
    }
}
</script>

<style scoped>
button {
    width: 120px;
}
</style>
